var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustedIconGlobeD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 10.4163 10.4164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.20817 0C2.33637 0 0 2.33637 0 5.20823C0 7.15619 1.07514 8.85746 2.66292 9.75066C3.41602 10.1743 4.28427 10.4164 5.20817 10.4164C6.13208 10.4164 7.00033 10.1743 7.75343 9.75066C9.34127 8.85746 10.4163 7.15613 10.4163 5.20823C10.4163 2.33643 8.07998 0 5.20817 0Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustedIconGlobeD);
export default __webpack_public_path__ + "static/media/trusted-icon-globe-d.bf0e9fc32c835c4c101cdc85078f6eea.svg";
export { ForwardRef as ReactComponent };